module.exports = __webpack_public_path__ + "seismic-engagement-viewer-ui.noThumbnail.5d077faf.png";